if (!customElements.get('product-bogo-picker')) {
  customElements.define(
    'product-bogo-picker',
    class ProductBogoPicker extends HTMLElement {
      connectedCallback() {
        this.formId = this.dataset.productFormId;
        if (!this.formId) return;

        this.dualBundle = this.dataset.calmiBogoDual === 'true';

        this.onRadioChange = this.onRadioChange.bind(this);
        this.addEventListener('change', this.onRadioChange);
        this.onBundleLineChange = this.onBundleLineChange.bind(this);
        this.querySelectorAll('[data-calmi-bogo-bundle-line]').forEach((el) => {
          el.addEventListener('change', this.onBundleLineChange);
        });

        this.syncFromSelection();
        this.placeVariantPickerInActiveSlot();
        this.initDemandLiveCount();

        if (typeof subscribe === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
          this.variantChangeUnsubscriber = subscribe(PUB_SUB_EVENTS.variantChange, () => {
            this.syncFromSelection();
            this.placeVariantPickerInActiveSlot();
          });
        }
      }

      disconnectedCallback() {
        this.removeEventListener('change', this.onRadioChange);
        this.querySelectorAll('[data-calmi-bogo-bundle-line]').forEach((el) => {
          el.removeEventListener('change', this.onBundleLineChange);
        });
        if (this.demandCountTimer) {
          clearInterval(this.demandCountTimer);
          this.demandCountTimer = null;
        }
        if (this.variantChangeUnsubscriber) {
          this.variantChangeUnsubscriber();
          this.variantChangeUnsubscriber = null;
        }
      }

      initDemandLiveCount() {
        const el = this.querySelector('[data-demand-live-count]');
        if (!el) return;

        let min = parseInt(el.getAttribute('data-min'), 10);
        let max = parseInt(el.getAttribute('data-max'), 10);
        if (!Number.isFinite(min)) min = 71;
        if (!Number.isFinite(max)) max = 143;
        if (max < min) max = min;

        const tick = () => {
          const n = Math.floor(Math.random() * (max - min + 1)) + min;
          el.textContent = String(n);
        };

        tick();
        this.demandCountTimer = setInterval(tick, 3000);
      }

      onRadioChange(event) {
        if (!event.target.matches('.product-bogo-offer__radio')) return;
        this.syncFromSelection();
        this.placeVariantPickerInActiveSlot();
      }

      onBundleLineChange(event) {
        event.stopPropagation();
      }

      placeVariantPickerInActiveSlot() {
        const variantSelects = this.querySelector('variant-selects');
        if (!variantSelects) return;

        const checked = this.querySelector('.product-bogo-offer__radio:checked');
        let slotKey = 'bundle';
        if (checked?.value === 'single') slotKey = 'single';
        else if (!checked && this.dataset.defaultOffer === 'single') slotKey = 'single';

        const singleSlot = this.querySelector('[data-calmi-bogo-variant-slot="single"]');
        const singleCombo = singleSlot?.querySelector(
          'calmi-bogo-variant-combo[data-mode="single"]'
        );
        const host = this.querySelector('[data-calmi-bogo-variant-host="hidden"]');

        if (singleCombo) {
          if (host) host.appendChild(variantSelects);
          return;
        }

        if (slotKey === 'single') {
          if (singleSlot) singleSlot.appendChild(variantSelects);
        } else if (host) {
          host.appendChild(variantSelects);
        }
      }

      removeBogoHiddenQuantity() {
        const form = document.getElementById(this.formId);
        form?.querySelector('input[name="quantity"][data-bogo-quantity]')?.remove();
      }

      ensureBogoHiddenQuantity() {
        const form = document.getElementById(this.formId);
        if (!form) return null;
        let el = form.querySelector('input[name="quantity"][data-bogo-quantity]');
        if (!el) {
          el = document.createElement('input');
          el.type = 'hidden';
          el.name = 'quantity';
          el.setAttribute('data-bogo-quantity', '');
          el.setAttribute('data-min', '1');
          form.appendChild(el);
        }
        return el;
      }

      getVisibleQuantityInput() {
        const root = this.closest('product-info');
        if (!root) return null;
        const byForm = root.querySelector(`.quantity__input[form="${this.formId}"]`);
        if (byForm) return byForm;
        return root.querySelector('.quantity__input');
      }

      syncFromSelection() {
        const checked = this.querySelector('.product-bogo-offer__radio:checked');
        const isSingle = checked?.value === 'single';
        const isBundleDual = !isSingle && this.dualBundle;

        const qty = isBundleDual ? 1 : isSingle ? 1 : 2;

        const visibleQty = this.getVisibleQuantityInput();
        if (visibleQty) {
          this.removeBogoHiddenQuantity();
          this.applyQuantity(visibleQty, qty);
          return;
        }

        const hiddenQty = this.ensureBogoHiddenQuantity();
        if (hiddenQty) this.applyQuantity(hiddenQty, qty);
      }

      applyQuantity(qtyInput, qty) {
        const min = parseInt(qtyInput.getAttribute('data-min'), 10);
        const minQty = Number.isFinite(min) ? min : 1;
        const maxAttr = qtyInput.getAttribute('data-max');
        const maxQty = maxAttr ? parseInt(maxAttr, 10) : null;

        let finalQty = qty;
        if (finalQty < minQty) finalQty = minQty;
        if (maxQty != null && !Number.isNaN(maxQty) && finalQty > maxQty) finalQty = maxQty;

        qtyInput.value = String(finalQty);
        qtyInput.dispatchEvent(new Event('change', { bubbles: true }));
      }
    }
  );
}
